import { useEffect, useRef, useState } from "react";
import "../../styles/layoutPicker.css";

export default function LayoutPicker({ pos, onSelect, onClose }) {
  const pickerRef = useRef(null);
  const [hoverCell, setHoverCell] = useState({ row: 0, col: 0 });
  const [selectedCell, setSelectedCell] = useState({ row: 0, col: 0 });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const activeCell = hoverCell.row > 0 ? hoverCell : selectedCell;

  const isHighlighted = (r, c) =>
    r <= activeCell.row && c <= activeCell.col;

  const handleClick = (r, c) => {
    setSelectedCell({ row: r, col: c });
    onSelect(r, c);
    onClose();
  };

  return (
    <div
      ref={pickerRef}
      className="layoutPicker"
      style={{ top: pos.top, left: pos.left }}
    >
      <div className="layoutPickerTitle">LAYOUT</div>

      <div
        className="hoverGrid"
        onMouseLeave={() => setHoverCell({ row: 0, col: 0 })}
      >
        {[1, 2, 3].map((r) =>
          [1, 2, 3].map((c) => (
            <div
              key={`${r}-${c}`}
              className={`hoverCell ${isHighlighted(r, c) ? "active" : ""}`}
              onMouseEnter={() => setHoverCell({ row: r, col: c })}
              onClick={() => handleClick(r, c)}
            />
          ))
        )}
      </div>

      <div className="layoutLabel">
        {activeCell.row > 0
          ? `${activeCell.row} × ${activeCell.col}`
          : "\u00A0"}
      </div>
    </div>
  );
}